import React, { useState, useEffect } from "react"
import { NavLink, useNavigate } from "react-router-dom"
import { Layout, Menu, Typography, Select } from "antd"
import {
    DashboardOutlined,
    LoginOutlined,
    LogoutOutlined,
    UserOutlined,
    TableOutlined,
    PlusCircleOutlined,
    MenuOutlined,
    CloseOutlined,
    UnorderedListOutlined,
    UserAddOutlined,
    EditOutlined,
    SettingOutlined
} from "@ant-design/icons"
import { useUser } from "./contexts/UserContext"

import "./FixedSider.css"
import { CookiesProvider, useCookies } from 'react-cookie'
import { useTranslation } from "react-i18next"

import { BrowserView, MobileView, isMobile } from 'react-device-detect';

const { Sider } = Layout

const FixedSider = () => {
    const [isSiderVisible, setIsSiderVisible] = useState(true)
    const { user, logout } = useUser()
    const navigate = useNavigate()
    const [touchStart, setTouchStart] = useState(null)
    const [touchEnd, setTouchEnd] = useState(null)
    const [cookies, setCookie] = useCookies(['language'])

    const { t, i18n } = useTranslation()

    const minSwipeDistance = 50

    useEffect(() => {
      /*  const handleTouchStart = (e) => {
            setTouchEnd(null)
            setTouchStart(e.targetTouches[0].clientX)
        }

        const handleTouchMove = (e) => {
            setTouchEnd(e.targetTouches[0].clientX)
        }

        const handleTouchEnd = () => {
            if (!touchStart || !touchEnd) return
            const distance = touchStart - touchEnd
            const isLeftSwipe = distance > minSwipeDistance
            const isRightSwipe = distance < -minSwipeDistance

           // if (isLeftSwipe) {
           //     setIsSiderVisible(false)
           // } else if (isRightSwipe) {
            //    setIsSiderVisible(true)
           // }
        }

        window.addEventListener("touchstart", handleTouchStart)
        window.addEventListener("touchmove", handleTouchMove)
        window.addEventListener("touchend", handleTouchEnd)
        */

        if (isMobile) {
            setIsSiderVisible(false);
        }

        i18n.changeLanguage(cookies.language);
        console.log(cookies.language);

        return () => {
           // window.removeEventListener("touchstart", handleTouchStart)
          //  window.removeEventListener("touchmove", handleTouchMove)
           // window.removeEventListener("touchend", handleTouchEnd)
        }
    }, [touchStart, touchEnd, setIsSiderVisible])

    const handleLogout = () => {
        if (window.innerWidth <= 767) {
            setIsSiderVisible(false)
        }
        logout()
        navigate("/login")
    }

    const toggleSider = () => setIsSiderVisible((prev) => !prev)

    const menuItems = [
        ...(user
            ? [
                  {
                      key: "1",
                      icon: <DashboardOutlined />,
                    label: <NavLink to="/dashboard">{t('page.fixedsider.dashboard')}</NavLink>
                },
                {
                    key: "20",
                    icon: <SettingOutlined />,
                    label: <NavLink to={`/edit-account/${user.id}`}>{t('page.fixedsider.edit-account')}</NavLink>
                }
              ]
            : []),
        ...(user && (user.role !== "User")
            ? [
                  {
                      key: "3",
                      icon: <UserOutlined />,
                    label: <NavLink to="/flow">{t('page.fixedsider.flow')}</NavLink>
                  },
                  {
                      key: "6",
                      icon: <PlusCircleOutlined />,
                      label: <NavLink to="/register-user">{t('page.fixedsider.register-user')}</NavLink>
                  },
                  ...(user.role === "SuperAdmin"
                      ? [/*
                            {
                                key: "7",
                                icon: <UnorderedListOutlined />,
                                label: <NavLink to="/product-management">Produktadministration</NavLink>
                            },
                            {
                                key: "9",
                                icon: <EditOutlined />,
                                label: <NavLink to="/edit-thresholds">Redigera Tröskelvärde</NavLink>
                            }
                       */ ]
                      : [])
              ]
            : []),
        ...(user && (user.role === "Admin" || user.role == "SuperAdmin")
            ?[
                {
                    key: "10",
                    icon: <EditOutlined />,
                    label: <NavLink to="/accountmanager">{t('page.fixedsider.accountmanager')}</NavLink>
                }/*,
                {
                    key: "2",
                    icon: <TableOutlined />,
                    label: <NavLink to="/table">Offertgenerator</NavLink>
                }*/
            ]
             : []),
        ...(user
            ? [
                  {
                      key: "4",
                      icon: <LogoutOutlined />,
                    label: t('page.fixedsider.logout'),
                      onClick: handleLogout
                  }
              ]
            : [
                  {
                      key: "5",
                      icon: <LoginOutlined />,
                    label: <NavLink to="/login">{t('page.fixedsider.login')}</NavLink>
                  }
              ])
    ]

    const setLanguage = (value: string) =>
    {
        setCookie('language', value);
        window.location.reload(true);
    };

    return (
        <>
            {isSiderVisible && <div className={`sider-backdrop ${isSiderVisible ? "mobile-visible" : ""}`} onClick={toggleSider} />}
            <Sider
                className={`fixed-sider ${isSiderVisible ? "mobile-visible" : ""}`}
                
                collapsedWidth="0"
                collapsed={!isSiderVisible}
                onCollapse={null/*(collapsed) => setIsSiderVisible(!collapsed)*/}
                trigger={null}
                width="14rem"
            >
                <div className="logo" style={{ margin: "10px", display: "flex", justifyContent: "center" }}>
                    <img src="/AquaExpert_logo_devis.png" alt="Aqua Expert Logo" style={{ width: "80%" }} />
                </div>
                <Menu theme="dark" mode="inline" defaultSelectedKeys={["1"]} items={menuItems} />
                <Select
                    defaultValue={cookies.language == 'sv' ? "Svenska" : "English" }
                    style={{ width: "140px", left: "25px", marginTop: "30px" }}
                    onChange={setLanguage}
                    options={[
                        { value: 'sv', label: 'Svenska' },
                        { value: 'en', label: 'English' }
                    ]}
                >
                    
                </Select>
                {user && (
                    <div style={{ position: "absolute", bottom: 30, width: "100%", textAlign: "center" }}>
                        <Typography.Text style={{ color: "lightgray" }}>{t('page.fixedsider.loggedinas') + " " + user.username}</Typography.Text>
                    </div>
                )}
            </Sider>
            <div className={`sider-trigger ${isSiderVisible ? "mobile-visible" : ""}`} onClick={toggleSider}>
                {isSiderVisible ? <CloseOutlined /> : <MenuOutlined />}
            </div>
            {isSiderVisible && <div className="hidden-overlay" onClick={() => setIsSiderVisible(false)}></div>}
        </>
    )
}

export default FixedSider
